import { api } from './client';
import type { CharacterTracker, AddTrackerRequest, UpdateTrackerRequest } from '@charbuilder/shared';

export async function addTracker(characterId: string, dto: AddTrackerRequest): Promise<CharacterTracker> {
  const { data } = await api.post(`/characters/${characterId}/trackers`, dto);
  return data;
}

export async function updateTracker(
  characterId: string,
  trackerId: string,
  dto: UpdateTrackerRequest,
): Promise<CharacterTracker> {
  const { data } = await api.patch(`/characters/${characterId}/trackers/${trackerId}`, dto);
  return data;
}

export async function deleteTracker(characterId: string, trackerId: string): Promise<void> {
  await api.delete(`/characters/${characterId}/trackers/${trackerId}`);
}
